module.exports = __webpack_public_path__ + "img/marker-purple.84e38551.svg";